module.exports = __webpack_public_path__ + "img/gold13.c99e592a.gif";